import { forwardRef } from 'react'
import { styled } from 'styled-components'
import { NextSeo } from 'next-seo'
import { useTranslation } from '@pancakeswap/localization'
import { useRouter } from 'next/router'
import { Button, Flex, Text } from '@pancakeswap/uikit'
import { ErrorBoundary } from 'components/ErrorBoundary'
import { DEFAULT_META, getCustomMeta } from 'config/constants/meta'
import Container from './Container'

const ErrorCard = styled(Flex)`
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 12px;
  max-width: 420px;
  margin: 80px auto;
  padding: 40px 32px;
  text-align: center;
  border: 1px solid ${({ theme }) => theme.colors.cardBorder};
  border-radius: 24px;
  background: ${({ theme }) => theme.colors.backgroundAlt};
  box-shadow: 0 16px 40px -16px rgba(0, 0, 0, 0.6);
`

const RouteErrorFallback = () => (
  <ErrorCard>
    <Text fontSize="20px" bold>
      Something went wrong
    </Text>
    <Text color="textSubtle" fontSize="14px">
      This page hit an unexpected error. Reloading usually fixes it.
    </Text>
    <Button mt="8px" onClick={() => window.location.reload()}>
      Reload page
    </Button>
  </ErrorCard>
)

const StyledPage = styled(Container)`
  width: 100%;
  min-height: calc(100vh - 64px);
  padding-top: 8px;
  padding-bottom: 16px;
  margin: auto;

  ${({ theme }) => theme.mediaQueries.sm} {
    padding-top: 12px;
    padding-bottom: 24px;
  }

  ${({ theme }) => theme.mediaQueries.lg} {
    padding-top: 12px;
    padding-bottom: 32px;
  }
`

export const PageMeta: React.FC<React.PropsWithChildren> = () => {
  const {
    t,
    currentLanguage: { locale },
  } = useTranslation()
  const { pathname } = useRouter()

  const pageMeta = getCustomMeta(pathname, t, locale)

  // if (!pageMeta) {
  //   return null
  // }

  // const { description, image } = { ...DEFAULT_META }

  return (
    <NextSeo
      title={pageMeta?.title}
      // description={description}
      // openGraph={
      //   image
      //     ? {
      //         images: [{ url: image, alt: pageMeta?.title, type: 'image/png' }],
      //       }
      //     : undefined
      // }
    />
  )
}

const Page = forwardRef<HTMLDivElement, React.PropsWithChildren<React.HTMLAttributes<HTMLDivElement>>>(
  ({ children, ...props }, ref) => {
    return (
      <>
        <PageMeta />
        <StyledPage ref={ref} {...props}>
          <ErrorBoundary fallback={<RouteErrorFallback />}>{children}</ErrorBoundary>
        </StyledPage>
      </>
    )
  },
)

export default Page
